import { render, staticRenderFns } from "./PayOrderList.vue?vue&type=template&id=70990172&scoped=true"
import script from "./PayOrderList.vue?vue&type=script&lang=js"
export * from "./PayOrderList.vue?vue&type=script&lang=js"
import style0 from "./PayOrderList.vue?vue&type=style&index=0&id=70990172&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70990172",
  null
  
)

export default component.exports